import getConfig from "next/config";
import { GrowthBook } from "@growthbook/growthbook-react";
import { GetServerSidePropsContext } from "next";
import { pushEvent } from "helpers/analytics";
import { getClientCookie } from "helpers/cookies";

export { GrowthBookProvider } from "@growthbook/growthbook-react";

const { publicRuntimeConfig } = getConfig();

const attributeNameMap = {
  clientId: "cid",
};

const getUniversalClientId = (ctx?: GetServerSidePropsContext) => {
  let cookie;
  if (ctx) {
    cookie = ctx?.req.cookies["_ga"];
  } else {
    cookie = getClientCookie("_ga");
  }

  if (cookie) {
    return cookie.split(".").slice(-2).join(".");
  }
};

const growthBookConfig = {
  apiHost: publicRuntimeConfig.GROWTHBOOK_API_HOST,
  clientKey: publicRuntimeConfig.GROWTHBOOK_CLIENT_KEY,
  trackingCallback: (experiment, result) => {
    pushEvent({
      event: "experiment_viewed",
      event_category: "experiment",
      event_label: result.variationId,
      event_action: experiment.key,
      dimension11: experiment.key + ":" + result.variationId,
    });
  },
  /* Enable easier debugging of feature flags during development. Also disable cache on refresh feature state */
  enableDevMode:
    publicRuntimeConfig.IS_DEV ||
    publicRuntimeConfig.NODE_ENV === "development", // enable for zc-dev
};

export const createGrowthBook = (): GrowthBook => {
  const clientId = getUniversalClientId();
  const gb = new GrowthBook({
    ...growthBookConfig,
    attributes: {
      [attributeNameMap.clientId]: getUniversalClientId(),
    },
  });
  const clientIdUpdate = ({ detail }: CustomEvent) => {
    if (detail?.event === "client_id_is_ready") {
      gb.setAttributes({
        [attributeNameMap.clientId]: detail[attributeNameMap.clientId],
      });
      window.removeEventListener("datalayerpush", clientIdUpdate);
    }
  };

  if (!clientId && typeof window !== "undefined") {
    window.addEventListener("datalayerpush", clientIdUpdate);
  }

  return gb;
};

function getServerSideGrowthBookContext(context?: GetServerSidePropsContext) {
  // Set GrowthBook polyfills
  /*setPolyfills({
    fetch: globalThis.fetch || require("cross-fetch"),
    EventSource: globalThis.EventSource || require("eventsource"),
    SubtleCrypto: globalThis.crypto?.subtle || require("node:crypto")?.webcrypto?.subtle
  });*/

  return {
    ...growthBookConfig,
    attributes: {
      [attributeNameMap.clientId]: getUniversalClientId(context),
      forceKey: (context && context.req.headers["ex-force-key"]) ?? null,
    },
  };
}

export function createSSRGrowthBook(context: GetServerSidePropsContext) {
  return new GrowthBook(getServerSideGrowthBookContext(context));
}
